import { CustomerTypes } from '../../../_mock/@types';

export const calculateTotalProfitabilityAmount = (array: CustomerTypes[]) => {
  const totalAmount = array.reduce(
    (prevValue, currValue) => prevValue + currValue.totalProfitability,
    0
  );
  return totalAmount;
};
